import {createApp} from 'vue';
import SignForm from './components/SignForm';
import Modal from './components/Modal';
import ModalAutoSave from './components/ModalAutoSave';
import Tablelist from './components/fields/Tablelist.vue';
import Dictionary from './components/fields/Dictionary.vue';
import Checkbox from './components/fields/Checkbox.vue';
import TextArea from './components/fields/TextArea.vue';
import TextField from './components/fields/TextField.vue';
import Fields from './components/fields/Fields.vue';
import FileInput from './components/FileInput.vue';
import {CkeditorPlugin} from '@ckeditor/ckeditor5-vue';
import DeadlineEditor from './components/DeadlineEditor.vue';
import * as Sentry from '@sentry/browser';
import HeadSelector from './components/HeadSelector.vue';
import FileUploader from './components/FileUploader.vue';
import CommentAttacher from './components/CommentAttacher.vue';
import ManagerSelector from './components/ManagerSelector.vue';

require('./bootstrap');

const app = createApp({});

app.mixin({
    methods: {
        getLang: function () {
            return document.querySelector('html').getAttribute('lang') || 'ru';
        },
        getToken: function () {
            return document.head.querySelector('meta[name="csrf-token"]').getAttribute('content');
        },
    },
});

app.component('sign-form', SignForm);
app.component('modal', Modal);
app.component('modal-auto-save', ModalAutoSave);
app.component('table-list', Tablelist);
app.component('dictionary', Dictionary);
app.component('checkbox', Checkbox);
app.component('text-area', TextArea);
app.component('text-field', TextField);
app.component('fields', Fields);
app.component('file-input', FileInput);
app.component('deadline-editor', DeadlineEditor);
app.component('head-selector', HeadSelector);
app.component('file-uploader', FileUploader);
app.component('comment-attacher', CommentAttacher);
app.component('manager-selector', ManagerSelector);
app.use(CkeditorPlugin);

app.mount('#app');

if (process.env.MIX_SENTRY_ENABLED === 'true') {
    Sentry.init({
        dsn: process.env.MIX_SENTRY_URL,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: 1.0,
    });
}

$(document).ready(function() {
    $('.select2').select2({width: 'resolve'});

    $('.modal__open').click(function() {
        $(this).addClass('active');
        $(this).next('.modal__block').css('display', 'block');
    });

    $('.modal__close').click(function() {
        const modal = $(this).closest('.modal__block');
        modal.hide();
        modal.prev('.modal__open').removeClass('active');
    });
});

document.addEventListener('DOMContentLoaded', function () {
    /**
     * Отключает кнопку после клика, чтобы избежать повторной отправки формы
     */
    const applyButtons = document.querySelectorAll('.apply-btn');
    applyButtons.forEach(button => {
        button.addEventListener('click', function () {
            if (this.dataset.bsToggle === 'modal') {
                return;
            }

            this.classList.add('disabled');
            this.setAttribute('disabled', 'disabled');
        });
    });

    /**
     * Обработчик события, который "оживляет" кнопки при возврате на страницу
     * из кэша браузера (после нажатия кнопки "Назад").
     */
    window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            applyButtons.forEach(button => {
                if (button.hasAttribute('disabled')) {
                    button.classList.remove('disabled');
                    button.removeAttribute('disabled');
                }
            });
        }
    });
});
